import React, { useState } from "react";
import { Box, Modal, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import img1 from "../../assets/ResortGallery/RG1.jpg";
import img2 from "../../assets/ResortGallery/RG2.jpg";
import img3 from "../../assets/ResortGallery/RG3.jpg";
import img4 from "../../assets/ResortGallery/RG4.jpg";
import img6 from "../../assets/ResortGallery/RG5.jpg";
import img5 from "../../assets/ResortGallery/RG6.jpg";
import img7 from "../../assets/ResortGallery/RG14.jpg";
import img8 from "../../assets/ResortGallery/RG8.jpg";
import img9 from "../../assets/ResortGallery/RG9.jpg";
import img10 from "../../assets/ResortGallery/RG10.jpg";
import img11 from "../../assets/ResortGallery/RG11.jpg";
import img12 from "../../assets/ResortGallery/RG12.jpg";
import img13 from "../../assets/ResortGallery/RG13.jpg";

const SmallScreenImageChart = () => {
    const [open, setOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13];
    
    const handleOpen = (index) => {
        setCurrentImageIndex(index);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const handlePrev = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    const handleNext = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };

    const sections = [
        [
            { src: img1, alt: "Two Home" },
            { src: img2, alt: "Cycle" },
        ],
        [
            { src: img3, alt: "Skytree" }
        ],
        [
            { src: img4, alt: "Red Roof" }
        ],
        [
            { src: img5, alt: "Two Chair" },
            { src: img6, alt: "Cycle" },
        ],
        [
            { src: img7, alt: "Icon 1" }
        ],
        [
            { src: img8, alt: "Two Home" },
            { src: img9, alt: "Cycle" },
        ],
        [
            { src: img10, alt: "Skytree" }
        ],
        [
            { src: img11, alt: "Red Roof" }
        ],
        [
            { src: img12, alt: "Two Chair" },
            { src: img13, alt: "Cycle" },
        ],
    ];

    return (
        <>
            {sections.map((section, idx) => (
                <Box
                    key={idx}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "90%",
                        margin: "0 auto",
                        gap: "2%",
                        marginBottom: "2%",
                    }}
                >
                    <Box sx={{ display: "flex", gap: "2%" }}>
                        {section.map((img, imgIdx) => (
                            <img
                                key={imgIdx}
                                src={img.src}
                                alt={img.alt}
                                style={{
                                    width: section.length === 1 ? "100%" : "49%",
                                    objectFit: "cover",
                                    cursor: "pointer",
                                }}
                                onClick={() => handleOpen(images.indexOf(img.src))}
                            />
                        ))}
                    </Box>
                </Box>
            ))}

            <Modal
                open={open}
                onClose={handleClose}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        width: "90%",
                        maxWidth: "600px",
                        height: "80%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {/* Image */}
                    <Box
                        component="img"
                        src={images[currentImageIndex]}
                        alt={`Image ${currentImageIndex}`}
                        sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            flexGrow: 1,
                            position: "relative",
                        }}
                    />

                    {/* Close Button */}
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            top: "7%",
                            right: "10px",
                            border: "1px solid #E1D9CF",
                            backgroundColor: "rgba(0, 0, 0, 0.5)", 
                            color: "#E1D9CF",
                            borderRadius: "0",
                            zIndex: 2, 
                        }}
                    >
                        <CloseIcon sx={{ fontSize: "16px" }} />
                    </IconButton>

                    {/* Navigation Buttons */}
                    <IconButton
                        onClick={handlePrev}
                        sx={{
                            position: "absolute",
                            left: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            border: "1px solid #E4CAAE",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            color: "#E1D9CF",
                            borderRadius: "0",
                            zIndex: 2,
                        }}
                    >
                        <ArrowBackIcon sx={{ fontSize: "16px" }} />
                    </IconButton>

                    <IconButton
                        onClick={handleNext}
                        sx={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            border: "1px solid #E4CAAE",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            color: "#E1D9CF",
                            borderRadius: "0",
                            zIndex: 2,
                        }}
                    >
                        <ArrowForwardIcon sx={{ fontSize: "16px" }} />
                    </IconButton>
                </Box>
            </Modal>


        </>
    );
};

export default SmallScreenImageChart;
